"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAndCreateI18nEntries = exports.createPropertiesI18nEntries = exports.createCapI18nEntries = void 0;
var cap_1 = require("./cap");
Object.defineProperty(exports, "createCapI18nEntries", { enumerable: true, get: function () { return cap_1.createCapI18nEntries; } });
var properties_1 = require("./properties");
Object.defineProperty(exports, "createPropertiesI18nEntries", { enumerable: true, get: function () { return properties_1.createPropertiesI18nEntries; } });
Object.defineProperty(exports, "removeAndCreateI18nEntries", { enumerable: true, get: function () { return properties_1.removeAndCreateI18nEntries; } });
//# sourceMappingURL=index.js.map